import { createContext } from "react";

const UserProfileContext = createContext();

export default UserProfileContext;
